var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "order",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40.485,
    height: 34.043,
    viewBox: "0 0 40.485 34.043",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 40.485,
    height: 34.043,
    fill: "#d51a66"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M40.485,24.91a3.92,3.92,0,0,0-3.268-3.86A16.9,16.9,0,0,0,24.028,5.5l1.388-2.044L22.93,0H17.555L15.069,3.456,16.49,5.547A16.662,16.662,0,0,0,12.8,6.88H3.242V9.252H9.275q-.437.382-.852.795a17.35,17.35,0,0,0-1.3,1.453H0v2.372H5.548a16.709,16.709,0,0,0-1.026,2.247h-2.7v2.373H3.84a17,17,0,0,0-.333,2.525A3.92,3.92,0,0,0,0,24.91v3.4H2.853a4.052,4.052,0,1,0,7.372,0H30.259a4.052,4.052,0,1,0,7.372,0h2.853ZM17.963,3.495l.808-1.123h2.943l.808,1.123-1.115,1.64c-.347-.021-.7-.033-1.046-.033q-.64,0-1.274.047Zm2.4,3.98A14.528,14.528,0,0,1,34.836,21H5.886A14.527,14.527,0,0,1,20.361,7.474M8.22,29.99a1.68,1.68,0,1,1-1.68-1.68,1.682,1.682,0,0,1,1.68,1.68m27.406,0a1.68,1.68,0,1,1-1.68-1.68,1.682,1.682,0,0,1,1.68,1.68m2.487-4.052H2.372V24.91a1.544,1.544,0,0,1,1.542-1.541H36.571a1.544,1.544,0,0,1,1.542,1.541Z",
    fill: "#d51a66"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.224bbba704f85ad13f91371d4d40de1d.svg";
export { ForwardRef as ReactComponent };